"use client"

import {
    Box,
    Button,
    Grid,
    Typography,
    Stepper,
    Step,
    StepLabel,
    StepConnector,
    stepConnectorClasses,
    styled,
    Chip,
    Table,
    TableHead,
    TableRow,
    TableBody,
    TableCell,
    TextField,
    DialogContent,
    DialogTitle,
    InputLabel,

    Dialog,
    IconButton,
    DialogContentText,
    DialogActions,
    Divider,
    useMediaQuery,
    createTheme,
    Container,
    Paper,
    Card,
    CardContent,
    TableContainer,
    Alert,
    MenuItem,
    FormControl,
    Select,
} from "@mui/material"
import CheckIcon from "@mui/icons-material/Check"
import HelpIcon from '@mui/icons-material/Help';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import EditIcon from "@mui/icons-material/Edit"
import LocationOnIcon from "@mui/icons-material/LocationOn"
import BusinessIcon from "@mui/icons-material/Business"
import PaymentIcon from "@mui/icons-material/Payment"
import { Fragment, useEffect, useState } from "react"
import Images from "../../../assets/images"
import DeleteIcon from "@mui/icons-material/Delete";
import InputField2 from "../../../components/inputField2"
import { useForm, Controller } from "react-hook-form"
import dayjs from 'dayjs'
import MultiSelectField from "../../../components/MultiSelect"
import SelectField from "../../../components/SelectField"
import CircleIcon from "@mui/icons-material/Circle";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers"
import AuthServices from "../../../api/VoucherServices"
import { useNavigate } from "react-router-dom"
import moment from "moment"
import { SuccessToaster } from "../../../components/Toaster"
import VoucherServices from "../../../api/VoucherServices/index";
import OrderServices from "../../../api/orderServices/order.index"
import { useAuth } from "../../../context/index";
import LogoutIcon from "@mui/icons-material/Logout";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import TwitterIcon from "@mui/icons-material/Twitter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import { currencyType, currencyType2 } from "../../../utils";
import { AccountBalance, AttachMoney, CheckCircle, Payment, Pending, ShoppingBag, TrendingUp } from "@mui/icons-material";


// Custom connector (same as original form)
const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`&.${stepConnectorClasses.alternativeLabel}`]: {
        top: 0,
    },
    [`&.${stepConnectorClasses.active} .${stepConnectorClasses.line}`]: {
        borderColor: "#00C6FF",
    },
    [`&.${stepConnectorClasses.completed} .${stepConnectorClasses.line}`]: {
        borderColor: "#00C6FF",
    },
    [`& .${stepConnectorClasses.line}`]: {
        borderColor: "#374e5b",
        borderWidth: 1,
        minHeight: "40px",
    },
}))

const VendorDetailPage = () => {
    const { user } = useAuth();
    console.log(user);
    const [currency, setCurrency] = useState('PKR')
    const [activeStep, setActiveStep] = useState(0)
    const [open, setOpen] = useState(false)
    const [date, setDate] = useState(null)
    const [date2, setDate2] = useState(null)
    const [status, setStatus] = useState(null)
    const [offerType, setOfferType] = useState(null)
    const [vendorData, setVendorData] = useState(null)
    const [selectedStatus, setSelectedStatus] = useState(null)
    const [vouchers, setVouchers] = useState([])
    const [open3, setOpen3] = useState(false)
    const { userLogout2 } = useAuth();
    const [startDate, setStartDate] = useState("")
    const [endDate, setEndDate] = useState("")
    const [orders2, setOrders2] = useState([])
    const [filteredOrders, setFilteredOrders] = useState([])

    // Initialize mock data on mount
    useEffect(() => {
        const storedOrders = localStorage.getItem("vendorOrders")
        if (storedOrders) {
            setOrders2(JSON.parse(storedOrders))
            setFilteredOrders(JSON.parse(storedOrders))
        } else {
            // Mock initial data
            const mockOrders = [
                {
                    id: "ORD-001",
                    date: "2025-01-15",
                    customer: "Sarah Johnson",
                    items: "Summer Dress, Sandals",
                    amount: 129.99,
                    status: "paid",
                },
                {
                    id: "ORD-002",
                    date: "2025-01-18",
                    customer: "Mike Chen",
                    items: "Leather Jacket",
                    amount: 299.99,
                    status: "unpaid",
                },
                {
                    id: "ORD-003",
                    date: "2025-01-20",
                    customer: "Emily Davis",
                    items: "Denim Jeans, T-Shirt",
                    amount: 89.99,
                    status: "paid",
                },
                {
                    id: "ORD-004",
                    date: "2025-01-22",
                    customer: "James Wilson",
                    items: "Sneakers",
                    amount: 149.99,
                    status: "unpaid",
                },
                {
                    id: "ORD-005",
                    date: "2025-01-25",
                    customer: "Lisa Anderson",
                    items: "Evening Gown",
                    amount: 399.99,
                    status: "paid",
                },
            ]
            localStorage.setItem("vendorOrders", JSON.stringify(mockOrders))
            setOrders2(mockOrders)
            setFilteredOrders(mockOrders)
        }
    }, [])

    const [payouts, setPayouts] = useState([])
    const [paymentMethod, setPaymentMethod] = useState(null)
    const [openRequestDialog, setOpenRequestDialog] = useState(false)
    const [openMethodDialog, setOpenMethodDialog] = useState(false)
    const [requestAmount, setRequestAmount] = useState("")
    const [methodType, setMethodType] = useState("bank")
    const [bankDetails, setBankDetails] = useState({
        accountName: "",
        accountNumber: "",
        bankName: "",
        routingNumber: "",
    })
    const [paypalEmail, setPaypalEmail] = useState("")

    // Load data from localStorage on mount
    useEffect(() => {
        const storedPayouts = localStorage.getItem("vendorPayouts")
        const storedMethod = localStorage.getItem("vendorPaymentMethod")

        if (storedPayouts) {
            setPayouts(JSON.parse(storedPayouts))
        } else {
            // Mock initial data
            const mockPayouts = [
                {
                    id: "PAY-001",
                    requestDate: "2025-01-10",
                    amount: 450.0,
                    status: "paid",
                    paidDate: "2025-01-12",
                    method: "Bank Transfer",
                },
                {
                    id: "PAY-002",
                    requestDate: "2025-01-20",
                    amount: 320.0,
                    status: "pending",
                    paidDate: null,
                    method: "Bank Transfer",
                },
            ]
            localStorage.setItem("vendorPayouts", JSON.stringify(mockPayouts))
            setPayouts(mockPayouts)
        }

        if (storedMethod) {
            setPaymentMethod(JSON.parse(storedMethod))
        }
    }, [])

    const handleRequestPayout = () => {
        if (!paymentMethod) {
            alert("Please set up a payment method before requesting a payout.")
            return
        }
        setOpenRequestDialog(true)
    }

    const handleSubmitRequest = () => {
        if (!requestAmount || Number.parseFloat(requestAmount) <= 0) {
            alert("Please enter a valid amount.")
            return
        }

        const newPayout = {
            id: `PAY-${String(payouts.length + 1).padStart(3, "0")}`,
            requestDate: new Date().toISOString().split("T")[0],
            amount: Number.parseFloat(requestAmount),
            status: "pending",
            paidDate: null,
            method: paymentMethod.type === "bank" ? "Bank Transfer" : "PayPal",
        }

        const updatedPayouts = [...payouts, newPayout]
        setPayouts(updatedPayouts)
        localStorage.setItem("vendorPayouts", JSON.stringify(updatedPayouts))
        setRequestAmount("")
        setOpenRequestDialog(false)
    }

    const handleSavePaymentMethod = () => {
        let method
        if (methodType === "bank") {
            if (!bankDetails.accountName || !bankDetails.accountNumber || !bankDetails.bankName) {
                alert("Please fill in all bank details.")
                return
            }
            method = { type: "bank", details: bankDetails }
        } else {
            if (!paypalEmail) {
                alert("Please enter a PayPal email.")
                return
            }
            method = { type: "paypal", details: { email: paypalEmail } }
        }

        setPaymentMethod(method)
        localStorage.setItem("vendorPaymentMethod", JSON.stringify(method))
        setOpenMethodDialog(false)
    }

    const calculateStats2 = () => {
        const totalPaid = payouts.filter((p) => p.status === "paid").reduce((sum, p) => sum + p.amount, 0)
        const totalPending = payouts.filter((p) => p.status === "pending").reduce((sum, p) => sum + p.amount, 0)
        const totalPayouts = payouts.length

        return { totalPaid, totalPending, totalPayouts }
    }

    const stats2 = calculateStats2()

    const handleFilter = () => {
        if (!startDate && !endDate) {
            setFilteredOrders(orders)
            return
        }

        const filtered = orders.filter((order) => {
            const orderDate = new Date(order.date)
            const start = startDate ? new Date(startDate) : null
            const end = endDate ? new Date(endDate) : null

            if (start && end) {
                return orderDate >= start && orderDate <= end
            } else if (start) {
                return orderDate >= start
            } else if (end) {
                return orderDate <= end
            }
            return true
        })

        setFilteredOrders(filtered)
    }

    const handleClearFilter = () => {
        setStartDate("")
        setEndDate("")
        setFilteredOrders(orders2)
    }

    const calculateStats = () => {
        const totalOrders = filteredOrders.length
        const paidOrders = filteredOrders.filter((o) => o.status === "paid").length
        const unpaidOrders = filteredOrders.filter((o) => o.status === "unpaid").length
        const totalEarnings = filteredOrders.filter((o) => o.status === "paid").reduce((sum, o) => sum + o.amount, 0)
        const unpaidAmount = filteredOrders.filter((o) => o.status === "unpaid").reduce((sum, o) => sum + o.amount, 0)

        return { totalOrders, paidOrders, unpaidOrders, totalEarnings, unpaidAmount }
    }

    const stats = calculateStats()

    const platformIcons = {
        facebook: <FacebookIcon sx={{ color: "#0BD1D1", fontSize: '32px' }} />,
        instagram: <InstagramIcon sx={{ color: "#0BD1D1", fontSize: '32px' }} />,
        twitter: <TwitterIcon sx={{ color: "#0BD1D1", fontSize: '32px' }} />,
        linkedin: <LinkedInIcon sx={{ color: "#0BD1D1", fontSize: '32px' }} />,
    };

    const navigate = useNavigate()
    const {
        register,
        handleSubmit,
        formState: { errors },
        setValue,
        control,
        reset,
    } = useForm({
        defaultValues: {
            name: "",
            code: "",
            baseCustomer: [],
            status: "",
            offerType: "",
            amount: "",
            percentage: "",
        },
    });
    const [orders, setOrders] = useState([])
    const handleGetOrders = async (page, limit, filter) => {


        let params = {
            page: 1,
            limit: 999999,
            vendor_id: user?._id
        };
        try {
            const { data, responseCode, message } = await OrderServices.getOrders(
                params
            );

            setOrders(data.orders);

        } catch (error) {
            console.error("Error while fetching users:", error);
        }
    };
    const [voucherData, setVoucherData] = useState([])
    const steps = [
        "Merchant Details",
        "Operating Region",
        "Product Types Offered",
        "Product Setup",
        "Shipping Details",
        "Marketing Material",
        "Taxation Details",
        "Other Details",
        "Voucher Codes",
        "Orders",
        "My Earnings",
        "My Payments",
    ]


    const voucherList = async (page, limit) => {
        const Page = 1;
        const Limit = 99999;

        try {
            const { data, responseCode, message } = await VoucherServices.voucherList(Page, Limit);
            console.log(data);
            setVoucherData(data?.vouchers)


        } catch (error) {
            console.error("Error while fetching users:", error);
        }
    };

    const onSubmit = async (formData) => {
        console.log("Form formData:", formData);
        setOpen(false)
        // API call here

        try {



            let obj = {
                id: vendorData?.id,
                name: formData?.name,
                code: formData?.code,
                discount_type: offerType?.id,
                is_active: selectedStatus?.id == 'active' ? true : false,
                discount_value: formData?.amount,
                min_order_value: formData?.minOrderValue,
                start_date: moment(new Date(formData?.date)).format('MM-DD-YYYY'),
                end_date: moment(new Date(formData?.expiryDate)).format('MM-DD-YYYY')
            }



            console.log(obj);

            const { data } = await AuthServices.createVoucher(obj)
            console.log(data?.voucher, 'vouchervoucher')
            if (data?.voucher) {
                setSelectedStatus(null)
                setOfferType(null)
                reset()
                setOpen(false)
                voucherList()
                SuccessToaster("Voucher created successfully");

            }

        } catch (error) {
            console.log(error)
        }

    };

    const transformVendorData = (apiData) => {
        return {
            ...apiData,
            id: apiData?._id,
            brandName: apiData?.name || "",
            contactPersonName: apiData?.cp_name || "",
            email: apiData?.email || "",
            city: apiData?.city || '',
            states: apiData?.operating_states || "",
            phoneNumber: apiData?.phone || "",
            address1: apiData?.address_1 || "",
            state: apiData?.state || "",
            zipCode: apiData?.zip || "",
            cities: apiData?.operating_cities || [],
            printingMethods: apiData?.printing_methods || [],
            standardInState: apiData?.shipping?.standard?.instate_price?.toString() || "",
            standardOutState: apiData?.shipping?.standard?.outstate_price?.toString() || "",
            standardShirts: apiData?.shipping?.standard?.quantity_limit?.toString() || "",
            premiumInState: apiData?.shipping?.premium?.instate_price?.toString() || "",
            premiumOutState: apiData?.shipping?.premium?.outstate_price?.toString() || "",
            premiumShirts: apiData?.shipping?.premium?.quantity_limit?.toString() || "",
            expressInState: apiData?.shipping?.express?.instate_price?.toString() || "",
            expressOutState: apiData?.shipping?.express?.outstate_price?.toString() || "",
            expressShirts: apiData?.shipping?.express?.quantity_limit?.toString() || "",
            portfolioImages: apiData?.past_work || [],
            socialPlatform: apiData?.social_medias?.[0]?.type || "",
            socialUrl: apiData?.social_medias?.[0]?.link || "",
            businessDescription: apiData?.business_description || "",
            taxId: apiData?.tax_number || "",
            printDays: apiData?.days_to_print?.toString() || "",
            supportContact: apiData?.email || "",
            agree: true,
            products: apiData?.products?.map((p) => ({
                productType: {
                    id: apiData?.product_type || "",
                    name: apiData?.product_type || "",
                },
                fabric: (p.fabrics || []).map((f) => ({ id: f.toLowerCase(), name: f })),
                premium_fabrics: (p.premium_fabrics || []).map((f) => ({ id: f.toLowerCase(), name: f })),
                adultSize: (p.adult_sizes || []).map((s) => ({ id: s.toLowerCase(), name: s })),
                youthSize: (p.youth_sizes || []).map((s) => ({ id: s.toLowerCase(), name: s })),
                color: p.colors || [],
                standardOneSide: p.one_side_standard?.toString() || "",
                standardDoubleSide: p.double_side_standard?.toString() || "",
                standardAdditional: p.additional_standard?.toString() || "",
                standardDescription: p.description_standard || "",
                premiumOneSide: p.one_side_premium?.toString() || "",
                premiumDoubleSide: p.double_side_premium?.toString() || "",
                premiumAdditional: p.additional_premium?.toString() || "",
                premiumDescription: p.description_premium || "",
                sampleImages: p.sample_images || [],
                pictures: p.sample_images || [],
            })) || [],
        };
    };

    const getVendorDetail = async () => {



        try {



            const { data } = await AuthServices.getVendorDetail();
            console.log(data);
            let vendor = data?.vendor
            console.log(vendor, 'vendorvendor');
            setCurrency(vendor?.currency ? vendor?.currency : 'USD')
            const vendorData2 = transformVendorData(vendor);
            console.log(vendorData2, 'vendorData');

            setVendorData(vendorData2); // if using useState


        } catch (error) {
            console.error("❌ API Error:", error);
        }
    };
    useEffect(() => {
        getVendorDetail()
        handleGetOrders()
    }, [])


    const InfoCard = ({ icon, label, value, isArray = false, sx }) => (
        <Box sx={{ mb: 0, ...sx }}>
            <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                {icon}
                <Typography variant="body2" sx={{ color: "#a3abb2", ml: 1, fontWeight: 600 }}>
                    {label}
                </Typography>
            </Box>
            {isArray ? (
                <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                    {value.map((item, index) => (
                        <Chip
                            key={index}
                            label={item}
                            size="small"
                            sx={{
                                backgroundColor: "rgba(0, 188, 212, 0.1)",
                                color: "#00BCD4",
                                border: "1px solid #00BCD4",
                            }}
                        />
                    ))}
                </Box>
            ) : (
                <Typography variant="body1" sx={{ color: "white", ml: 3 }}>
                    {value}
                </Typography>
            )}
        </Box>
    )

    const InfoField = ({ label, value, sx }) => (
        <Box sx={{ mb: 0 }}>
            <Typography variant="body2" sx={{ color: "#a3abb2", fontSize: "12px", mb: 0.5 }}>
                {label}
            </Typography>
            <Typography variant="body1" sx={{ color: "white", fontSize: "14px", wordBreak: 'break-all' }}>
                {value}
            </Typography>
        </Box>
    )
    const [open2, setOpen2] = useState(false)
    const [open4, setOpen4] = useState(false)
    const [selectedRow, setSelectedRow] = useState(null)
    const handleDeleteVoucher = async () => {
        console.log(selectedRow);

        let params = {
            id: selectedRow?._id
        }
        try {
            const { data, responseCode, message } = await VoucherServices.deleteVoucher(selectedRow?._id);
            SuccessToaster(message)
            voucherList()
            setOpen4(false);

        } catch (error) {
            console.error("Error while fetching users:", error);
        }
    };
    useEffect(() => {
        voucherList()
    }, [])
    const theme = createTheme({
        typography: {
            fontFamily: "Poppins, sans-serif", // You can change this to your preferred font
        },
        components: {
            MuiStepLabel: {
                styleOverrides: {
                    label: {
                        color: "rgba(255, 255, 255, 0.7)",
                        fontFamily: "Poppins, sans-serif",
                        "&.Mui-active": {
                            color: "#ffffff",
                        },
                        "&.Mui-completed": {
                            color: "#ffffff",
                        },
                    },
                },
            },
            MuiTextField: {
                styleOverrides: {
                    root: {
                        "& .MuiInputBase-root": {
                            color: "white", // Text color,
                            fontFamily: "Poppins, sans-serif",
                        },
                        "& .MuiInputLabel-root": {
                            color: "white", // Label color
                        },
                        "& .MuiInput-underline:before": {
                            borderBottomColor: "white", // Underline color when unfocused
                        },
                        "& .MuiInput-underline:after": {
                            borderBottomColor: "white", // Underline color when focused
                        },
                        "& .MuiOutlinedInput-root": {
                            "& fieldset": {
                                borderColor: "white", // Border color when unfocused
                            },
                            "&:hover fieldset": {
                                borderColor: "white", // Border color on hover
                            },
                            "&.Mui-focused fieldset": {
                                borderColor: "white", // Border color when focused
                            },
                        },
                    },
                },
            },
            MuiInputBase: {
                styleOverrides: {
                    input: {
                        color: "white", // Text color for input
                    },
                },
            },
            MuiOutlinedInput: {
                styleOverrides: {
                    notchedOutline: {
                        borderColor: "white", // Border color for input
                    },
                    root: {
                        "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "white",
                        },
                        "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "white",
                        },
                    },
                },
            },
            MuiInputLabel: {
                styleOverrides: {
                    root: {
                        color: "white", // Text color for label
                        borderColor: "white",
                        "&.Mui-focused": {
                            color: "white",
                        },
                    },
                },
            },
            MuiMenuItem: {
                styleOverrides: {
                    root: {
                        color: "black", // Text color for menu items
                        backgroundColor: "white", // Background color for menu items
                        "&.Mui-selected": {
                            backgroundColor: "rgba(255, 255, 255, 0.2)", // Background color for selected item
                        },
                        "&:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.1)", // Background color for hover
                        },
                    },
                },
            },
            MuiSvgIcon: {
                styleOverrides: {
                    root: {
                        color: "white", // Color for dropdown arrow
                    },
                },
            },
        },
        palette: {
            primary: {
                main: "#1976d2",
            },
            background: {
                default: "#333333",
            },
        },
    });
    const isMobile = useMediaQuery(theme.breakpoints.down("md"));
    const isMobile2 = useMediaQuery(theme.breakpoints.down("lg"));
    return (
        <div style={{ background: "#0F172A" }}>
            <Dialog
                open={open3}
                onClose={() => setOpen3(false)}
                maxWidth="md"
                PaperProps={{
                    sx: {
                        backgroundColor: "#1a2537", // Set dialog background to black
                        color: "white", // Make sure text stays visible
                        borderRadius: 3,
                        width: '400px',

                    },
                }}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"

            >
                <DialogTitle sx={{ textAlign: 'center' }} id="confirm-dialog-title">Are You Sure?</DialogTitle>

                <DialogActions sx={{ display: 'flex', justifyContent: 'center', pb: 3 }}>
                    <Button
                        onClick={() => {
                            setOpen2(false)
                            userLogout2()

                        }
                        }
                        variant="contained"

                        sx={{
                            background: "#00BCD4",
                            color: "white",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: '#101A33',
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": {
                                background: "#00ACC1",
                            },
                        }}

                    >
                        Yes
                    </Button>
                    <Button
                        onClick={() => setOpen2(false)}
                        variant="contained"

                        sx={{
                            background: "#00BCD4",
                            color: "white",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: '#101A33',
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": {
                                background: "#00ACC1",
                            },
                        }}

                    >
                        No
                    </Button>


                </DialogActions>
            </Dialog>
            <Dialog
                open={open2}
                onClose={() => setOpen2(false)}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"
            >
                <DialogTitle id="confirm-dialog-title">Confirm Delete</DialogTitle>
                <DialogContent>
                    <DialogContentText id="confirm-dialog-description">
                        Are you sure you want to delete this item?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setOpen2(false)} color="primary">No</Button>
                    <Button onClick={handleDeleteVoucher} color="secondary" autoFocus>Yes</Button>
                </DialogActions>
            </Dialog>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                fullWidth
                maxWidth="md"
                PaperProps={{
                    sx: {
                        background: "#192133",
                        borderRadius: "16px",
                        p: 4,
                        color: "white",
                    },
                }}
            >
                <Typography variant="h6" sx={{ fontWeight: 600, mb: 3 }}>
                    Create New Voucher Code
                </Typography>

                <form onSubmit={handleSubmit(onSubmit)}>
                    <Grid container spacing={2}>
                        {/* Voucher Name */}
                        <Grid item xs={12} md={6}>
                            <InputField2
                                fullWidth
                                label="Voucher Name"
                                placeholder="Enter voucher name"
                                error={errors?.name?.message}
                                register={register("name", {
                                    required: "Please enter voucher name.",
                                })}
                            />
                        </Grid>

                        {/* Code */}
                        <Grid item xs={12} md={6}>
                            <InputField2
                                fullWidth
                                label="Code"
                                placeholder="Enter voucher code"
                                error={errors?.code?.message}
                                register={register("code", {
                                    required: "Please enter voucher code.",
                                })}
                            />
                        </Grid>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            {/* Generate Date */}
                            <Grid item xs={12} md={4}>
                                <label style={{ color: "#a3abb2", fontWeight: 600, fontFamily: "Maven Pro, sans-serif " }}>Generate Date</label>
                                <Controller
                                    name="date"
                                    control={control}
                                    rules={{ required: "Please select a date" }}
                                    defaultValue={dayjs()}
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            value={field.value || null}
                                            format="DD/MM/YYYY"
                                            onChange={(newValue) => {
                                                field.onChange(newValue);
                                                setValue("date", newValue);
                                            }}
                                            disablePast={true}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    sx: {

                                                        "& .MuiOutlinedInput-root": {
                                                            color: "#a3abb2",
                                                            backgroundColor: "#273346",
                                                            mt: 1,
                                                            height: "50px",
                                                            borderRadius: "10px",
                                                            "& fieldset": { border: "2px solid #475569" },
                                                            "&:hover fieldset": {
                                                                border: "2px solid #475569",
                                                            },
                                                            "& .MuiSvgIcon-root": {
                                                                color: "#0BD1D1 !important",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                border: "2px solid #475569 !important",
                                                            },
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    )}
                                />
                                {errors.date && (
                                    <Typography color="#d32f2f" sx={{ fontSize: "12px" }}>
                                        {errors.date.message}
                                    </Typography>
                                )}
                            </Grid>

                            {/* Expiry Date */}
                            <Grid item xs={12} md={4}>
                                <label style={{ color: "#a3abb2", fontWeight: 600, fontFamily: "Maven Pro, sans-serif " }}>Expiry Date</label>
                                <Controller
                                    name="expiryDate"
                                    control={control}
                                    rules={{ required: "Please select expiry date" }}
                                    defaultValue={dayjs()}
                                    render={({ field }) => (
                                        <DatePicker
                                            {...field}
                                            value={field.value || null}
                                            format="DD/MM/YYYY"
                                            onChange={(newValue) => {
                                                field.onChange(newValue);
                                                setValue("expiryDate", newValue);
                                            }}
                                            disablePast={true}
                                            slotProps={{
                                                textField: {
                                                    size: "small",
                                                    fullWidth: true,
                                                    sx: {

                                                        "& .MuiOutlinedInput-root": {
                                                            color: "#a3abb2",
                                                            backgroundColor: "#273346",
                                                            mt: 1,
                                                            height: "50px",
                                                            borderRadius: "10px",
                                                            "& fieldset": { border: "2px solid #475569" },
                                                            "&:hover fieldset": {
                                                                border: "2px solid #475569",
                                                            },
                                                            "& .MuiSvgIcon-root": {
                                                                color: "#0BD1D1 !important",
                                                            },
                                                            "&.Mui-focused fieldset": {
                                                                border: "2px solid #475569 !important",
                                                            },
                                                        },
                                                    },
                                                },
                                            }}
                                        />
                                    )}
                                />
                                {errors.expiryDate && (
                                    <Typography color="#d32f2f" sx={{ fontSize: "12px" }}>
                                        {errors.expiryDate.message}
                                    </Typography>
                                )}
                            </Grid>
                        </LocalizationProvider>

                        {/* Status */}
                        <Grid item xs={12} md={4}>
                            <SelectField
                                label="Status"
                                error={errors?.status?.message}
                                register={register("status", {
                                    required: selectedStatus ? false : "Please select status.",
                                })}
                                selected={selectedStatus}

                                onSelect={(value) => setSelectedStatus(value)}
                                options={[
                                    { id: "active", name: "Active" },
                                    { id: "inactive", name: "Inactive" },
                                    { id: "expired", name: "Expired" },
                                ]}
                            />
                        </Grid>

                        {/* Offer Type */}
                        <Grid item xs={12} md={4}>
                            <SelectField
                                label="Offer Type"
                                error={errors?.offerType?.message}
                                register={register("offerType", {
                                    required: offerType ? false : "Please select offer type.",
                                })}
                                selected={offerType}

                                onSelect={(value) => setOfferType(value)}
                                options={[
                                    { id: "Flat Discount", name: "Flat Discount" },
                                    { id: "Percentage", name: "Percentage" },

                                ]}
                            />
                        </Grid>


                        {/* Amount */}
                        <Grid item xs={12} md={4}>
                            <InputField2

                                fullWidth
                                label={offerType?.id == "Percentage" ? "Percentage" : 'Amount'}
                                placeholder={offerType?.id == "Percentage" ? "Percentage" : 'Amount'}
                                type="number"
                                error={errors?.amount?.message}
                                register={register("amount", {
                                    required: "Please enter amount.",
                                    valueAsNumber: true,
                                })}
                            />
                        </Grid>
                        <Grid item xs={12} md={4}>
                            <InputField2
                                fullWidth
                                label="Min Order Value"
                                placeholder="Min Order Value"
                                type="number"
                                error={errors?.minOrderValue?.message}
                                register={register("minOrderValue", {
                                    required: "Please enter min order value.",
                                    valueAsNumber: true,
                                })}
                            />
                        </Grid>
                        {/* Percentage */}

                    </Grid>


                    {/* Buttons */}
                    <Box sx={{ display: "flex", justifyContent: "flex-end", gap: 2, mt: 4 }}>
                        <Button
                            variant="outlined"
                            sx={{
                                color: "#0BD1D1",
                                border: "none",
                                px: 7,
                                py: 1.5,
                                borderRadius: 4,
                                textTransform: "none",
                                fontSize: "16px",
                                fontWeight: 600,
                                background: '#272e3f',
                                // "&:hover": { border: " 2px solid #00BCD4" },
                                mr: 2,

                            }}
                            onClick={() => setOpen(false)}
                        >
                            Cancel
                        </Button>
                        <Button
                            type="submit"
                            variant="contained"
                            sx={{
                                background: "#00BCD4",
                                px: 4,
                                py: 1.5,
                                borderRadius: "12px",
                                textTransform: "none",
                                fontSize: "16px",
                                fontWeight: 700,
                                color: "#101A33",
                                "&:hover": {
                                    background: "#00ACC1",
                                },
                            }}
                        >
                            Create Voucher
                        </Button>
                    </Box>
                </form>
            </Dialog>
            <Dialog
                open={open2}
                onClose={() => setOpen2(false)}
                maxWidth="md"
                PaperProps={{
                    sx: {
                        backgroundColor: "#1a2537", // Set dialog background to black
                        color: "white", // Make sure text stays visible
                        borderRadius: 3,
                        width: '400px',

                    },
                }}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"

            >
                <DialogTitle sx={{ textAlign: 'center' }} id="confirm-dialog-title">Are You Sure?</DialogTitle>

                <DialogActions sx={{ display: 'flex', justifyContent: 'center', pb: 3 }}>
                    <Button
                        onClick={() => {
                            setOpen2(false)
                            userLogout2()

                        }
                        }
                        variant="contained"

                        sx={{
                            background: "#00BCD4",
                            color: "white",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: '#101A33',
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": {
                                background: "#00ACC1",
                            },
                        }}

                    >
                        Yes
                    </Button>
                    <Button
                        onClick={() => setOpen2(false)}
                        variant="contained"

                        sx={{
                            background: "#00BCD4",
                            color: "white",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: '#101A33',
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": {
                                background: "#00ACC1",
                            },
                        }}

                    >
                        No
                    </Button>


                </DialogActions>
            </Dialog>
            <Dialog
                open={open4}
                onClose={() => setOpen4(false)}
                maxWidth="md"
                PaperProps={{
                    sx: {
                        backgroundColor: "#1a2537", // Set dialog background to black
                        color: "white", // Make sure text stays visible
                        borderRadius: 3,
                        width: '400px',

                    },
                }}
                aria-labelledby="confirm-dialog-title"
                aria-describedby="confirm-dialog-description"

            >
                <DialogTitle sx={{ textAlign: 'center' }} id="confirm-dialog-title">Are You Sure?</DialogTitle>

                <DialogActions sx={{ display: 'flex', justifyContent: 'center', pb: 3 }}>
                    <Button
                        onClick={() => {
                            setOpen4(false)
                            handleDeleteVoucher()

                        }
                        }
                        variant="contained"

                        sx={{
                            background: "#00BCD4",
                            color: "white",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: '#101A33',
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": {
                                background: "#00ACC1",
                            },
                        }}

                    >
                        Yes
                    </Button>
                    <Button
                        onClick={() => setOpen4(false)}
                        variant="contained"

                        sx={{
                            background: "#00BCD4",
                            color: "white",
                            px: 4,
                            py: 1.5,
                            borderRadius: 4,
                            textTransform: "none",
                            color: '#101A33',
                            fontSize: "16px",
                            fontWeight: 700,
                            "&:hover": {
                                background: "#00ACC1",
                            },
                        }}

                    >
                        No
                    </Button>


                </DialogActions>
            </Dialog>
            {/* Header Banner */}
            <Box
                sx={{
                    backgroundImage: `url("${Images.contactBg}")`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "center",
                    width: "100%",
                    height: { lg: "300px", md: '300px', sm: '150px', xs: '150px' },
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    position: "relative",
                }}
            >
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, pl: { xs: 0, md: 3 }, mb: 1 }}>
                    <IconButton sx={{ color: "#00BCD4" }} onClick={() => navigate(-1)}>
                        <ArrowBackIcon sx={{ width: { xs: 18, sm: 22, md: 25 } }} />
                    </IconButton>
                </Box>
                <Box
                    sx={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: 1.5,
                    }}
                >
                    <Box
                        component={"p"}
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "35px", xs: "18px" },
                            textAlign: "center",
                            fontFamily: "Maven Pro, sans-serif !important",
                        }}
                    >
                        {" "}
                        Vendor {" "}
                    </Box>

                    <Box
                        component={"span"}
                        className="banner-text heading-font"
                        sx={{
                            fontSize: { lg: "52px", md: "52px", sm: "35px", xs: "18px" },
                            textAlign: "center",
                            fontFamily: "Maven Pro, sans-serif !important",
                        }}
                    >
                        {" "}
                        Details{" "}
                    </Box>
                    {/* <p style={{ fontSize: '25px', textAlign: 'center', color: 'white', fontFamily: "Noto Sans, sans-serif", }}>Homepage || <span style={{ color: Colors.secondary }}>Contact Us</span></p> */}
                </Box>
                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1, pr: { xs: 0, md: 3 }, mb: 1 }}>

                    <IconButton sx={{ color: '#00BCD4' }} onClick={() => setOpen2(true)}>
                        <LogoutIcon sx={{ width: { xs: 18, sm: 22, md: 25 } }} />
                    </IconButton>
                </Box>
            </Box>

            <Box sx={{ height: { xs: (activeStep == 1 || activeStep == 2 || activeStep == 6 || activeStep == 7 || activeStep == 9) ? '100vh' : 'auto', md: 'auto' } }}>
                <Box
                    component={"section"}
                    sx={{
                        py: 8,
                        display: 'flex', justifyContent: 'center',
                        backgroundImage: `url(${Images.frameBg})`,
                        backgroundSize: "cover", // Adjust the image size
                        backgroundPosition: "center", // Position the image
                        backgroundRepeat: "no-repeat", // Avoid repeating the image,


                    }}
                >
                    <Box sx={{ width: { xs: '95%', md: '80%' } }}>
                        <Box sx={{ margin: "0 auto" }}>
                            <Grid container spacing={4}>
                                {/* Stepper Sidebar */}
                                <Grid item xs={12} md={3} lg={3} >
                                    <Box
                                        sx={{
                                            background: "#192133",
                                            borderRadius: 2,
                                            p: 2,
                                        }}
                                    >
                                        <Stepper
                                            orientation={isMobile2 ? 'horizontal' : "vertical"}
                                            connector={null}

                                            sx={{
                                                ".MuiStep-root": { padding: 0, margin: 0 },
                                                overflowX: isMobile2 ? 'scroll' : ''
                                            }}
                                        >
                                            {steps.map((label, index) => (
                                                <Step key={label}>
                                                    <StepLabel

                                                        icon={null}
                                                        onClick={() => setActiveStep(index)}
                                                        sx={{
                                                            width: 'max-content',
                                                            cursor: "pointer",
                                                            "& .MuiStepLabel-label": {
                                                                color: "#ffffff",
                                                                fontWeight: 400,
                                                                fontSize: "14px",
                                                                pt: 0, // remove forced padding
                                                            },
                                                            "& .MuiSvgIcon-root": {
                                                                display: "none",
                                                            },
                                                            px: 1
                                                        }}
                                                    >
                                                        <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
                                                            <Typography
                                                                variant="body2"
                                                                sx={{
                                                                    color: activeStep === index ? "#0BD1D1" : "#ffffff",
                                                                    fontWeight: activeStep === index ? 700 : 400,
                                                                    fontSize: "14px",
                                                                    transition: "all 0.3s ease",
                                                                    cursor: "pointer",
                                                                    "&:hover": {
                                                                        color: activeStep === index ? "#0BD1D1" : "#00C6FF",
                                                                    },
                                                                }}
                                                            >
                                                                {label}
                                                            </Typography>

                                                            {index != 11 && !isMobile2 && <Box
                                                                component="hr"
                                                                sx={{
                                                                    border: 0,
                                                                    height: isMobile2 ? 0 : '1px',
                                                                    background: "rgba(255,255,255,0.2)",
                                                                    width: "100%",
                                                                    mt: isMobile2 ? 0 : 0.8
                                                                }}
                                                            />}
                                                        </Box>
                                                    </StepLabel>
                                                </Step>
                                            ))}

                                        </Stepper>

                                    </Box>
                                </Grid>

                                {/* Detail Content */}
                                <Grid item xs={12} md={12} lg={9}>
                                    <Box
                                        sx={{
                                            background: "#1a2537",
                                            borderRadius: "15px",
                                            padding: "30px",
                                            border: "1px solid #D9D9D90D",

                                        }}
                                    >
                                        {/* Merchant Details */}
                                        {activeStep === 0 && (
                                            <Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                                    <Typography variant="h6" sx={{ color: "white", fontSize: "18px", fontWeight: 600 }}>
                                                        Merchant Details
                                                    </Typography>
                                                    <IconButton onClick={() => navigate("/vendor", { state: { step: 0, edit: true } })}>
                                                        <Box component={'img'} src={Images.editLite} sx={{
                                                            width: {
                                                                xs: 25, // small on mobile
                                                                sm: 25, // medium on tablets
                                                                md: 30, // default desktop
                                                                lg: 35, // large screens
                                                            },
                                                            height: {
                                                                xs: 25,
                                                                sm: 25,
                                                                md: 30,
                                                                lg: 35,
                                                            },
                                                        }} />
                                                    </IconButton>
                                                </Box>

                                                <Box
                                                    sx={{
                                                        width: "100%",
                                                        display: "flex",
                                                        flexDirection: "column",
                                                    }}
                                                >
                                                    <Grid
                                                        container
                                                        spacing={3}
                                                        alignItems="flex-start"
                                                    >
                                                        {/* Vendor Logo Card */}
                                                        <Grid item xs={12} md={6}>
                                                            <Box
                                                                sx={{
                                                                    width: "100%",
                                                                    height: { xs: 200, sm: 250, md: 305 },
                                                                    backgroundColor: "white",
                                                                    borderRadius: "8px",
                                                                    display: "flex",
                                                                    flexDirection: "column",
                                                                    alignItems: "center",
                                                                    justifyContent: "center",
                                                                    overflow: "hidden",
                                                                }}
                                                            >
                                                                <Box
                                                                    component="img"
                                                                    src={vendorData?.logo ? vendorData?.logo : 'https://community.softr.io/uploads/db9110/original/2X/7/74e6e7e382d0ff5d7773ca9a87e6f6f8817a68a6.jpeg'}
                                                                    alt="Vendor"
                                                                    sx={{
                                                                        width: "100%",
                                                                        height: "100%",

                                                                        objectFit: "cover",
                                                                    }}
                                                                />
                                                            </Box>
                                                        </Grid>

                                                        {/* Information Grid */}
                                                        <Grid item xs={12} md={6}>
                                                            <Grid container spacing={3}>
                                                                {/* First Row */}
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={6}

                                                                    sx={{
                                                                        borderRight: { md: "1px solid #474d5c" },
                                                                        pr: { md: 2 },
                                                                    }}
                                                                >
                                                                    <InfoField label="Brand Name" value={vendorData?.brandName} />
                                                                </Grid>
                                                                <Grid item xs={12}
                                                                    sm={6}
                                                                    md={6}>
                                                                    <InfoField
                                                                        label="Contact Person name"
                                                                        value={vendorData?.contactPersonName}
                                                                    />
                                                                </Grid>

                                                                {/* Second Row */}
                                                                <Grid
                                                                    item
                                                                    xs={12}
                                                                    sm={6}
                                                                    md={6}
                                                                    sx={{
                                                                        borderRight: { md: "1px solid #474d5c" },
                                                                        pr: { md: 2 },
                                                                    }}
                                                                >
                                                                    <InfoField label="Email Address" value={vendorData?.email} />
                                                                </Grid>
                                                                <Grid item xs={12}
                                                                    sm={6}
                                                                    md={6}>
                                                                    <InfoField label="Phone Number" value={vendorData?.phoneNumber} />
                                                                </Grid>

                                                                {/* Third Row */}
                                                                <Grid item xs={12}
                                                                    sm={6}
                                                                    md={6}>
                                                                    <InfoField label="Website Url" value={vendorData?.website} />
                                                                </Grid>

                                                                {/* Fourth Row */}
                                                                <Grid item xs={12}
                                                                    sm={6}
                                                                    md={6}>
                                                                    <InfoField label="Contact address" value={vendorData?.address1} />
                                                                </Grid>

                                                                {/* Fifth Row */}
                                                                <Grid item xs={12}
                                                                    sm={6}
                                                                    md={6}>
                                                                    <InfoField label="State" value={vendorData?.state} />
                                                                </Grid>
                                                                <Grid item xs={12}
                                                                    sm={6}
                                                                    md={6}>
                                                                    <InfoField label="City" value={vendorData?.city} />
                                                                </Grid>
                                                                <Grid item xs={12}
                                                                    sm={6}
                                                                    md={6}>
                                                                    <InfoField label="Zip Code" value={vendorData?.zipCode} />
                                                                </Grid>
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Box>

                                            </Box>
                                        )}

                                        {/* Operating Region */}
                                        {activeStep === 1 && (
                                            <Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                                    <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                        Operating Region
                                                    </Typography>
                                                    <IconButton onClick={() => navigate("/vendor", { state: { step: 1, edit: true } })}>
                                                        <Box component={'img'} src={Images.editLite} width={'25px'} />
                                                    </IconButton>
                                                </Box>
                                                <Grid container spacing={3}>
                                                    {console.log(vendorData, 'vendorData?.operating_states')}

                                                    <Grid item md={6} sm={6} xs={12}>
                                                        <InfoCard
                                                            icon={<LocationOnIcon sx={{ color: "#00BCD4" }} />}
                                                            label="State"
                                                            value={
                                                                vendorData?.states?.length > 0
                                                                    ? vendorData.states.map((state) => state).join(", ")
                                                                    : "Not specified"
                                                            }
                                                        />
                                                    </Grid>

                                                    <Grid item md={6} sm={6} xs={12}>
                                                        <InfoCard
                                                            icon={<LocationOnIcon sx={{ color: "#00BCD4" }} />}
                                                            label="Cities"
                                                            value={
                                                                Array.isArray(vendorData?.cities) && vendorData?.cities.length > 0
                                                                    ? vendorData.cities.map((city) => city).join(", ")
                                                                    : "Not specified"
                                                            }
                                                        />
                                                    </Grid>

                                                </Grid>
                                            </Box>
                                        )}

                                        {/* Product Types Offered */}
                                        {activeStep === 2 && (
                                            <Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                                    <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                        Product Types Offered
                                                    </Typography>
                                                    <IconButton onClick={() => navigate("/vendor", { state: { step: 2, edit: true } })}>
                                                        <Box component={'img'} src={Images.editLite} width={'25px'} />
                                                    </IconButton>
                                                </Box>

                                                <Box sx={{ borderRadius: "8px", }}>
                                                    {/* Selected Product Type */}
                                                    <Box sx={{ mb: 3 }}>
                                                        <Typography variant="body2" sx={{ color: "#a3abb2", mb: 1 }}>
                                                            Selected Product Type
                                                        </Typography>
                                                        <Box
                                                            sx={{
                                                                backgroundColor: "rgba(15, 23, 42, 0.8)",
                                                                border: "1px solid #374e5b",
                                                                borderRadius: "4px",
                                                                p: 2,
                                                                display: "flex",
                                                                alignItems: "center",
                                                                justifyContent: "space-between",
                                                            }}
                                                        >
                                                            <Typography sx={{ color: "white" }}>
                                                                {vendorData?.products?.[0]?.productType?.name || "T-Shirts"}
                                                            </Typography>
                                                            <Box
                                                                sx={{
                                                                    width: 0,
                                                                    height: 0,
                                                                    borderLeft: "5px solid transparent",
                                                                    borderRight: "5px solid transparent",
                                                                    borderTop: "5px solid #a3abb2",
                                                                }}
                                                            />
                                                        </Box>
                                                    </Box>

                                                    {/* Printing Methods */}
                                                    <Box sx={{ mb: 3 }}>
                                                        <Typography variant="body2" sx={{ color: "#a3abb2", mb: 2 }}>
                                                            Printing Methods
                                                        </Typography>
                                                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                                            {["Screen", "DTG", "DTF", "Laser"].map((method) => (
                                                                <Box
                                                                    key={method}
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 1,
                                                                        backgroundColor: (vendorData?.printingMethods || []).includes(method)
                                                                            ? "#00BCD4"
                                                                            : "rgba(15, 23, 42, 0.8)",
                                                                        color: (vendorData?.printingMethods || []).includes(method) ? "#101A33" : "white",
                                                                        px: 2,
                                                                        py: 1,
                                                                        borderRadius: "20px",
                                                                        border: "1px solid #374e5b",
                                                                        minWidth: "80px",
                                                                        justifyContent: "center",
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            width: 12,
                                                                            height: 12,
                                                                            borderRadius: "50%",
                                                                            border: `2px solid ${(vendorData?.printingMethods || []).includes(method) ? "#101A33" : "#a3abb2"}`,
                                                                            backgroundColor: (vendorData?.printingMethods || []).includes(method)
                                                                                ? "#101A33"
                                                                                : "transparent",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                        }}
                                                                    >
                                                                        {(vendorData?.printingMethods || []).includes(method) && (
                                                                            <Box
                                                                                sx={{
                                                                                    width: 6,
                                                                                    height: 6,
                                                                                    borderRadius: "50%",
                                                                                    backgroundColor: "#00BCD4",
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </Box>
                                                                    <Typography variant="body2" sx={{ fontSize: "14px" }}>
                                                                        {method}
                                                                    </Typography>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Box>

                                                    {/* Half Tone Printing Question */}
                                                    <Box>
                                                        <Typography variant="body2" sx={{ color: "#a3abb2", mb: 2 }}>
                                                            Do you provide Half Tone Printing?
                                                        </Typography>
                                                        <Box sx={{ display: "flex", gap: 2 }}>
                                                            {["Yes", "No"].map((option) => (
                                                                <Box
                                                                    key={option}
                                                                    sx={{
                                                                        display: "flex",
                                                                        alignItems: "center",
                                                                        gap: 1,
                                                                        color: "white",
                                                                    }}
                                                                >
                                                                    <Box
                                                                        sx={{
                                                                            width: 16,
                                                                            height: 16,
                                                                            borderRadius: "50%",
                                                                            border: `2px solid ${option === "Yes" ? "#00BCD4" : "#a3abb2"}`,
                                                                            backgroundColor: option === "Yes" ? "#00BCD4" : "transparent",
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            justifyContent: "center",
                                                                        }}
                                                                    >
                                                                        {option === "Yes" && (
                                                                            <Box
                                                                                sx={{
                                                                                    width: 8,
                                                                                    height: 8,
                                                                                    borderRadius: "50%",
                                                                                    backgroundColor: "#101A33",
                                                                                }}
                                                                            />
                                                                        )}
                                                                    </Box>
                                                                    <Typography variant="body2">{option}</Typography>
                                                                </Box>
                                                            ))}
                                                        </Box>
                                                    </Box>
                                                </Box>
                                            </Box>
                                        )}

                                        {/* Product Setup */}
                                        {activeStep === 3 && (
                                            <Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                                    <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                        Product Setup
                                                    </Typography>
                                                    <IconButton onClick={() => navigate("/vendor", { state: { step: 3, edit: true } })}>
                                                        <Box component={'img'} src={Images.editLite} width={'25px'} />
                                                    </IconButton>
                                                </Box>

                                                {(vendorData?.products || []).map((product, index) => (
                                                    <Box key={index} sx={{ mb: 4, border: "1px solid #374e5b", borderRadius: "8px", p: 3 }}>
                                                        <Typography variant="h6" sx={{ color: "#00BCD4", mb: 2 }}>
                                                            {product?.productType?.name || "Product"}
                                                        </Typography>
                                                        <Grid container spacing={3}>
                                                            <Grid item xs={12} md={6}>
                                                                <InfoCard
                                                                    icon={<BusinessIcon sx={{ color: "#00BCD4" }} />}
                                                                    label="Standard Fabric Types"
                                                                    value={(product?.fabric || []).map((f) => f?.name || "Unknown")}
                                                                    isArray={true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <InfoCard
                                                                    icon={<BusinessIcon sx={{ color: "#00BCD4" }} />}
                                                                    label="Premium Fabric Types"
                                                                    value={(product?.premium_fabrics || []).map((f) => f?.name || 'Unknown')}
                                                                    isArray={true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <InfoCard
                                                                    icon={<BusinessIcon sx={{ color: "#00BCD4" }} />}
                                                                    label="Adult Sizes"
                                                                    value={(product?.adultSize || []).map((s) => s?.name || "Unknown")}
                                                                    isArray={true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <InfoCard
                                                                    icon={<BusinessIcon sx={{ color: "#00BCD4" }} />}
                                                                    label="Youth Sizes"
                                                                    value={(product?.youthSize || []).map((s) => s?.name || "Unknown")}
                                                                    isArray={true}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Box sx={{ mb: 2 }}>
                                                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                                                        <BusinessIcon sx={{ color: "#00BCD4" }} />
                                                                        <Typography variant="body2" sx={{ color: "#a3abb2", ml: 1, fontWeight: 600 }}>
                                                                            Available Colors
                                                                        </Typography>
                                                                    </Box>
                                                                    <Box sx={{ display: "flex", gap: 1, ml: 3 }}>
                                                                        {(product?.color || []).map((color, colorIndex) => (
                                                                            <Box
                                                                                key={colorIndex}
                                                                                sx={{
                                                                                    width: 30,
                                                                                    height: 30,
                                                                                    backgroundColor: color,
                                                                                    borderRadius: "4px",
                                                                                    border: "2px solid #374e5b",
                                                                                }}
                                                                            />
                                                                        ))}
                                                                    </Box>
                                                                </Box>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography variant="h6" sx={{ color: "#00BCD4", mb: 2 }}>
                                                                    Pricing - Standard
                                                                </Typography>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={12} sm={6} md={6} lg={4} >
                                                                        <InfoField label="One Side" value={`${currencyType2[vendorData?.country]?.code} ${product?.standardOneSide || "0"}`} />
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6} md={6} lg={4}>
                                                                        <InfoField label="Double Side" value={` ${currencyType2[vendorData?.country]?.code} ${product?.standardDoubleSide || "0"}`} />
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6} md={6} lg={4}>
                                                                        <InfoField label="Additional" value={`${currencyType2[vendorData?.country]?.code} ${product?.standardAdditional || "0"}`} />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <InfoField
                                                                            label="Description"
                                                                            value={product?.standardDescription || "No description"}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Typography variant="h6" sx={{ color: "#00BCD4", mb: 2 }}>
                                                                    Pricing - Premium
                                                                </Typography>
                                                                <Grid container spacing={2}>
                                                                    <Grid item xs={12} sm={6} md={6} lg={4}>
                                                                        <InfoField label="One Side" value={`$${product?.premiumOneSide || "0"}`} />
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6} md={6} lg={4}>
                                                                        <InfoField label="Double Side" value={`${currencyType2[vendorData?.country]?.code} ${product?.premiumDoubleSide || "0"}`} />
                                                                    </Grid>
                                                                    <Grid item xs={12} sm={6} md={6} lg={4}>
                                                                        <InfoField label="Additional" value={`${currencyType2[vendorData?.country]?.code} ${product?.premiumAdditional || "0"}`} />
                                                                    </Grid>
                                                                    <Grid item xs={12}>
                                                                        <InfoField
                                                                            label="Description"
                                                                            value={product?.premiumDescription || "No description"}
                                                                        />
                                                                    </Grid>
                                                                </Grid>
                                                            </Grid>
                                                            {product?.pictures && product.pictures.length > 0 && (
                                                                <Grid item xs={12}>
                                                                    <Box sx={{ mb: 2 }}>
                                                                        <Typography variant="body2" sx={{ color: "#a3abb2", mb: 1, fontWeight: 600 }}>
                                                                            Product Images
                                                                        </Typography>
                                                                        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
                                                                            {product.pictures.map((image, imgIndex) => (
                                                                                <Box
                                                                                    key={imgIndex}
                                                                                    component="img"
                                                                                    src={image}
                                                                                    sx={{
                                                                                        width: 100,
                                                                                        height: 100,
                                                                                        objectFit: "cover",
                                                                                        borderRadius: "8px",
                                                                                        border: "1px solid #374e5b",
                                                                                    }}
                                                                                />
                                                                            ))}
                                                                        </Box>
                                                                    </Box>
                                                                </Grid>
                                                            )}
                                                        </Grid>
                                                    </Box>
                                                ))}
                                            </Box>
                                        )}

                                        {/* Shipping Details */}
                                        {activeStep === 4 && (
                                            <Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                                    <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                        Shipping Details
                                                    </Typography>
                                                    <IconButton onClick={() => navigate("/vendor", { state: { step: 4, edit: true } })}>
                                                        <Box component={'img'} src={Images.editLite} width={'25px'} />
                                                    </IconButton>
                                                </Box>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" sx={{ color: "#00BCD4", mb: 2 }}>
                                                            Standard Shipping
                                                        </Typography>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="In City" value={`${currencyType2[vendorData?.country]?.code} ${vendorData?.standardInState}`} />
                                                            </Grid>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="Out City" value={`${currencyType2[vendorData?.country]?.code}  ${vendorData?.standardOutState}`} />
                                                            </Grid>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="Shirts Quantity" value={`  ${vendorData?.standardShirts}`} />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" sx={{ color: "#00BCD4", mb: 2 }}>
                                                            Premium Shipping
                                                        </Typography>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="In City" value={`${currencyType2[vendorData?.country]?.code}  ${vendorData?.premiumInState}`} />
                                                            </Grid>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="Out City" value={`${currencyType2[vendorData?.country]?.code}  ${vendorData?.premiumOutState}`} />
                                                            </Grid>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="Shirts Quantity" value={`  ${vendorData?.premiumShirts}`} />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                    <Grid item xs={12}>
                                                        <Typography variant="h6" sx={{ color: "#00BCD4", mb: 2 }}>
                                                            Express Shipping
                                                        </Typography>
                                                        <Grid container spacing={2}>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="In City" value={`${currencyType2[vendorData?.country]?.code}  ${vendorData?.expressInState}`} />
                                                            </Grid>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="Out City" value={`${currencyType2[vendorData?.country]?.code}  ${vendorData?.expressOutState}`} />
                                                            </Grid>
                                                            <Grid item xs={6} sm={4} md={4} lg={4}>
                                                                <InfoField label="Shirts Quantity" value={`  ${vendorData?.expressShirts}`} />
                                                            </Grid>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        )}

                                        {/* Marketing Material */}
                                        {activeStep === 5 && (
                                            <Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                                    <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                        Marketing Material
                                                    </Typography>
                                                    <IconButton onClick={() => navigate("/vendor", { state: { step: 5, edit: true } })}>
                                                        <Box component={'img'} src={Images.editLite} width={'25px'} />
                                                    </IconButton>
                                                </Box>

                                                {/* Business Description */}
                                                <Grid container spacing={3} flexDirection={'column'}>
                                                    <Grid item xs={12} md={6}>
                                                        <Grid item xs={12}>
                                                            <InfoCard
                                                                icon={<BusinessIcon sx={{ color: "#00BCD4" }} />}
                                                                label="Business Description"
                                                                value={vendorData?.businessDescription}
                                                            />
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                {/* Social Media Links */}
                                                <Grid container spacing={3} mt={3} flexDirection={'column'}>
                                                    <Typography variant="h6" sx={{ color: "white", pl: 3, mb: 0 }}>
                                                        Social Media Links
                                                    </Typography>
                                                    <Grid item xs={12} md={12}>
                                                        <Grid container spacing={2} m={0} mt={0}>
                                                            {vendorData?.social_medias?.map((link, index) => (
                                                                <InfoCard
                                                                    sx={{ mt: 2 }}
                                                                    key={index}
                                                                    icon={platformIcons[link?.type?.toLowerCase?.()]}
                                                                    label={link?.type}
                                                                    value={link?.link}
                                                                />
                                                            ))}
                                                        </Grid>
                                                    </Grid>
                                                </Grid>

                                                {/* Past Work Images */}
                                                <Grid container spacing={2} mt={3}>
                                                    <Typography variant="h6" sx={{ color: "white", pl: 3, mb: 2, width: "100%" }}>
                                                        Past Work
                                                    </Typography>
                                                    {vendorData?.past_work?.map((img, index) => (
                                                        <Grid item xs={12} sm={6} md={4} key={index}>
                                                            <Box
                                                                component="img"
                                                                src={img}
                                                                alt={`Past work ${index + 1}`}
                                                                sx={{
                                                                    width: "100%",
                                                                    height: "200px",
                                                                    objectFit: "cover",
                                                                    borderRadius: "12px",
                                                                }}
                                                            />
                                                        </Grid>
                                                    ))}
                                                </Grid>
                                            </Box>

                                        )}

                                        {/* Taxation Details */}
                                        {activeStep === 6 && (
                                            <Box>
                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                                    <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                        Taxation Details
                                                    </Typography>
                                                    <IconButton onClick={() => navigate("/vendor", { state: { step: 6, edit: true } })}>
                                                        <Box component={'img'} src={Images.editLite} width={'25px'} />
                                                    </IconButton>
                                                </Box>

                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6} sm={6}>
                                                        <InfoCard
                                                            icon={<PaymentIcon sx={{ color: "#00BCD4" }} />}
                                                            label="Tax ID"
                                                            value={vendorData?.taxId}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6} sm={6}>
                                                        <InfoCard
                                                            icon={<BusinessIcon sx={{ color: "#00BCD4" }} />}
                                                            label="State InCorporate"
                                                            value={`${vendorData?.state_incorporation}`}
                                                        />
                                                    </Grid>

                                                </Grid>
                                            </Box>
                                        )}

                                        {/* Other Details */}
                                        {activeStep === 7 && (
                                            <Box>

                                                <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3 }}>
                                                    <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                        Other Details
                                                    </Typography>
                                                    <IconButton onClick={() => navigate("/vendor", { state: { step: 7, edit: true } })}>
                                                        <Box component={'img'} src={Images.editLite} width={'25px'} />
                                                    </IconButton>
                                                </Box>
                                                <Grid container spacing={3}>
                                                    <Grid item xs={12} md={6} sm={6}>
                                                        <InfoCard
                                                            icon={<PictureAsPdfIcon
                                                                sx={{
                                                                    color: "#00BCD4",
                                                                    fontSize: 25,
                                                                    cursor: "pointer",

                                                                }}
                                                                onClick={() => window.open(vendorData?.return_document, "_blank")}
                                                            />}
                                                            label="Return/Refund Policy Info"
                                                            value={
                                                                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>

                                                                    <Typography
                                                                        variant="body2"
                                                                        sx={{
                                                                            color: "#00BCD4",
                                                                            cursor: "pointer",
                                                                            textDecoration: "underline",
                                                                            "&:hover": { textDecoration: "none" },
                                                                        }}
                                                                        onClick={() => window.open(vendorData?.return_document, "_blank")}
                                                                    >
                                                                        {vendorData?.return_document
                                                                            ? vendorData?.return_document.split("/").pop() // extracts filename from URL
                                                                            : "No document uploaded"}
                                                                    </Typography>
                                                                </Box>
                                                            }
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6} sm={6}>
                                                        <InfoCard
                                                            icon={<LocalShippingIcon sx={{ color: "#00BCD4" }} />}
                                                            label="No. Of Days To Print A Single Product"
                                                            value={vendorData?.days_to_print}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={12} md={6} sm={6}>
                                                        <InfoCard
                                                            icon={<HelpIcon sx={{ color: "#00BCD4" }} />}
                                                            label="Customer Support Contact Info"
                                                            value={vendorData?.support_email}
                                                        />
                                                    </Grid>
                                                </Grid>
                                            </Box>
                                        )}
                                        {activeStep === 8 && (
                                            <Box >
                                                <Box>
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: { xs: "flex-start", sm: "flex-end" },
                                                            flexDirection: { xs: "column", sm: "row" },
                                                            mb: 3,
                                                            gap: { xs: 2, sm: 0 },
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                color: "white",
                                                                mb: { xs: 0, sm: 3 },
                                                                fontSize: { xs: "16px", sm: "18px", md: "20px" },
                                                                fontWeight: 600,
                                                            }}
                                                        >
                                                            Voucher Code
                                                        </Typography>

                                                        <Button
                                                            variant="outlined"
                                                            sx={{
                                                                color: "#0BD1D1",
                                                                border: "2px solid #00BCD4",
                                                                px: { xs: 2, sm: 4, md: 5 },
                                                                py: { xs: 1, sm: 1.5 },
                                                                borderRadius: 4,
                                                                textTransform: "none",
                                                                fontSize: { xs: "13px", sm: "15px", md: "16px" },
                                                                fontWeight: 600,
                                                                "&:hover": { border: "2px solid #00BCD4" },
                                                                alignSelf: { xs: "stretch", sm: "auto" },
                                                            }}
                                                            onClick={() => setOpen(true)}
                                                        >
                                                            Create New Voucher
                                                        </Button>
                                                    </Box>

                                                    <Box
                                                        sx={{
                                                            backgroundColor: "#0F1B2D",
                                                            borderRadius: "8px",
                                                            overflowX: "auto", // ✅ horizontal scroll for smaller screens
                                                            overflowY: "hidden",
                                                            maxWidth: "100%",
                                                        }}
                                                    >
                                                        <Table
                                                            sx={{
                                                                minWidth: "700px", // ✅ ensures scroll triggers on smaller devices
                                                                borderCollapse: "collapse",
                                                            }}
                                                        >
                                                            <TableHead>
                                                                <TableRow sx={{ backgroundColor: "#0bd1d1" }}>
                                                                    {[
                                                                        "Start",
                                                                        "Expiry",
                                                                        "Name",
                                                                        "Code",
                                                                        "Status",
                                                                        "Type",
                                                                        "Amount/Percentage",
                                                                        "Action",
                                                                    ].map((header) => (
                                                                        <TableCell
                                                                            key={header}
                                                                            sx={{
                                                                                color: "#0F172A",
                                                                                fontWeight: 800,
                                                                                fontSize: { xs: "11px", sm: "12px" },
                                                                                border: "1px solid #0bd1d1",
                                                                                whiteSpace: "nowrap",
                                                                            }}
                                                                        >
                                                                            {header}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>

                                                            <TableBody>
                                                                {voucherData.map((voucher, index) => (
                                                                    <TableRow
                                                                        key={index}
                                                                        sx={{
                                                                            "&:nth-of-type(odd)": { backgroundColor: "#303747" },
                                                                            "&:hover": { backgroundColor: "#3b4252" },
                                                                        }}
                                                                    >
                                                                        <TableCell
                                                                            sx={{
                                                                                color: "white",
                                                                                fontSize: { xs: "11px", sm: "12px" },
                                                                                border: "1px solid #0bd1d1",
                                                                                width: "70px",
                                                                                whiteSpace: "nowrap",
                                                                            }}
                                                                        >
                                                                            {moment(voucher.start_date).format("DD-MM-YYYY")}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                color: "white",
                                                                                fontSize: { xs: "11px", sm: "12px" },
                                                                                border: "1px solid #0bd1d1",
                                                                                width: "70px",
                                                                                whiteSpace: "nowrap",
                                                                            }}
                                                                        >
                                                                            {moment(voucher.end_date).format("DD-MM-YYYY")}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                color: "white",
                                                                                fontSize: { xs: "11px", sm: "12px" },
                                                                                border: "1px solid #0bd1d1",
                                                                                whiteSpace: "nowrap",
                                                                            }}
                                                                        >
                                                                            {voucher.name}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                color: "white",
                                                                                fontSize: { xs: "11px", sm: "12px" },
                                                                                border: "1px solid #0bd1d1",
                                                                                whiteSpace: "nowrap",
                                                                            }}
                                                                        >
                                                                            {voucher.code}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                color: "white",
                                                                                fontWeight: 600,
                                                                                fontSize: { xs: "11px", sm: "12px" },
                                                                                border: "1px solid #0bd1d1",
                                                                            }}
                                                                        >
                                                                            {voucher.is_active ? "Active" : "Inactive"}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                color: "white",
                                                                                fontSize: { xs: "11px", sm: "12px" },
                                                                                border: "1px solid #0bd1d1",
                                                                                width: "80px",
                                                                            }}
                                                                        >
                                                                            {voucher.discount_type}
                                                                        </TableCell>

                                                                        <TableCell
                                                                            sx={{
                                                                                color: "white",
                                                                                fontSize: { xs: "11px", sm: "12px" },
                                                                                border: "1px solid #0bd1d1",
                                                                            }}
                                                                        >
                                                                            {voucher.discount_value}
                                                                        </TableCell>

                                                                        <TableCell sx={{ border: "1px solid #0bd1d1" }}>
                                                                            <Box sx={{ display: "flex", gap: 1 }}>
                                                                                <Box
                                                                                    component={"img"}
                                                                                    onClick={() => {
                                                                                        setSelectedRow(voucher);
                                                                                        setOpen4(true);
                                                                                    }}
                                                                                    src={Images.deletelite}
                                                                                    width={"20px"}
                                                                                    sx={{
                                                                                        cursor: "pointer",
                                                                                        transition: "0.2s",
                                                                                        "&:hover": { opacity: 0.7 },
                                                                                    }}
                                                                                />
                                                                            </Box>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                ))}
                                                            </TableBody>
                                                        </Table>
                                                    </Box>
                                                </Box>

                                            </Box>
                                        )}
                                        {activeStep === 9 && (
                                            <Box>
                                                <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                    Orders
                                                </Typography>
                                                <Grid container rowGap={3} justifyContent={"space-between"} >
                                                    {orders && orders.length > 0 ? (
                                                        orders.map((product, index) => (
                                                            <Grid
                                                                item
                                                                key={index}
                                                                lg={5.8}
                                                                md={5.8}
                                                                sm={12}
                                                                xs={12}
                                                                p={3}
                                                                onClick={() => navigate(`/order-detail`, { state: product })}
                                                                sx={{
                                                                    cursor: "pointer",
                                                                    backgroundColor: "#1b2335",
                                                                    borderRadius: "15px",
                                                                    transition: "0.3s",
                                                                    "&:hover": {
                                                                        backgroundColor: "#222b40",
                                                                        transform: "scale(1.01)",
                                                                    },
                                                                }}
                                                            >
                                                                {/* Order Header */}
                                                                <Box
                                                                    sx={{
                                                                        display: "flex",
                                                                        flexWrap: "wrap",
                                                                        justifyContent: "space-between",
                                                                        width: "100%",
                                                                        alignItems: "baseline",
                                                                        fontSize: { md: "15px", sm: "15px", xs: "13px" },
                                                                    }}
                                                                >
                                                                    <Box sx={{ color: "#7F92B0" }}>Order ID</Box>
                                                                    <Box
                                                                        component={"div"}
                                                                        className="heading-font"
                                                                        sx={{ fontWeight: 700, color: "white" }}
                                                                    >
                                                                        {product?.order_no}
                                                                    </Box>

                                                                    <Button
                                                                        variant="outlined"
                                                                        sx={{
                                                                            display: "flex",
                                                                            alignItems: "center",
                                                                            gap: 1,
                                                                            px: { xs: 2, sm: 4 },
                                                                            py: { xs: 0.5, sm: 1 },
                                                                            borderRadius: "8px",
                                                                            textTransform: "none",
                                                                            fontWeight: "bold",
                                                                            fontSize: { xs: "12px", sm: "14px" },
                                                                            backgroundColor:
                                                                                product?.status === "delivered" ? "#143D39" : "#5A4A1E",
                                                                            border:
                                                                                product?.status === "delivered"
                                                                                    ? "2px solid #3FBF43"
                                                                                    : "2px solid #D4AF37",
                                                                            color: "#FFFFFF",
                                                                            ":hover": {
                                                                                backgroundColor:
                                                                                    product?.status === "delivered" ? "#143D39" : "#5A4A1E",
                                                                                border:
                                                                                    product?.status === "delivered"
                                                                                        ? "2px solid #3FBF43"
                                                                                        : "2px solid #D4AF37",
                                                                            },
                                                                        }}
                                                                    >
                                                                        <CircleIcon sx={{ fontSize: 12, color: "white" }} />
                                                                        <Typography
                                                                            sx={{
                                                                                textTransform: "capitalize",
                                                                                fontSize: { md: "15px", sm: "15px", xs: "13px" },
                                                                            }}
                                                                        >
                                                                            {product?.status}
                                                                        </Typography>
                                                                    </Button>
                                                                </Box>

                                                                <Divider
                                                                    sx={{
                                                                        width: "100%",
                                                                        borderColor: "#B0B0B04D",
                                                                        mt: 2,
                                                                        mb: 2,
                                                                    }}
                                                                />

                                                                {/* Order Details */}
                                                                <Grid container spacing={0}>
                                                                    {[
                                                                        ["Customer Name", product?.customer?.name],
                                                                        ["Order Date", moment(product?.created_at).format("DD-MM-YYYY")],
                                                                        ["Quantity", product?.total_qty],
                                                                        ["Delivery Date", "TBD"],
                                                                        ["Payment Method", "Card"],
                                                                        ["Total Pricing", `${product?.total_amount} $`],
                                                                    ].map(([label, value], i) => (
                                                                        <Fragment key={i}>
                                                                            <Grid item xs={6} mt={2}>
                                                                                <Typography
                                                                                    variant="body2"
                                                                                    sx={{ color: "#8d919a", fontWeight: 500 }}
                                                                                >
                                                                                    {label}
                                                                                </Typography>
                                                                            </Grid>
                                                                            <Grid
                                                                                item
                                                                                xs={6}
                                                                                mt={2}
                                                                                sx={{ color: "white", fontWeight: 700 }}
                                                                            >
                                                                                {value}
                                                                            </Grid>
                                                                        </Fragment>
                                                                    ))}
                                                                </Grid>
                                                            </Grid>
                                                        ))
                                                    ) : (
                                                        <Grid item xs={12}>
                                                            <Box
                                                                sx={{
                                                                    textAlign: "center",
                                                                    color: "#7F92B0",
                                                                    fontSize: { xs: "14px", sm: "16px" },
                                                                    fontWeight: 600,
                                                                    mt: 4,
                                                                    mb: 4,
                                                                }}
                                                            >
                                                                🚀 No orders yet — your order history will appear here.
                                                            </Box>
                                                        </Grid>
                                                    )}

                                                </Grid>
                                            </Box>
                                        )}
                                        {activeStep === 10 && (
                                            <Box sx={{ bgcolor: "transparent", minHeight: "100vh" }}>

                                                <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                    My Earnings
                                                </Typography>

                                                {/* Date Filter */}
                                                <Paper
                                                    sx={{
                                                        p: 3,
                                                        mb: 3,
                                                        borderRadius: 2,
                                                        bgcolor: "#1b2335",
                                                        border: "1px solid rgba(255,255,255,0.1)",
                                                    }}
                                                >
                                                    <Typography
                                                        variant="h6"
                                                        sx={{
                                                            mb: 2,
                                                            fontWeight: 600,
                                                            color: "#0BD1D1",
                                                            fontFamily: "Maven Pro, sans-serif",
                                                        }}
                                                    >
                                                        Filter by Date Range
                                                    </Typography>
                                                    <Grid container spacing={2} alignItems="center">
                                                        <Grid item xs={12} sm={4}>
                                                            <TextField
                                                                label="Start Date"
                                                                type="date"
                                                                fullWidth
                                                                value={startDate}
                                                                onChange={(e) => setStartDate(e.target.value)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiInputBase-root": {
                                                                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                                                                        borderRadius: "12px",
                                                                        color: "white",
                                                                        transition: "0.3s",
                                                                        "&:hover": {
                                                                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                                        },
                                                                    },
                                                                    "& .MuiInputLabel-root": {
                                                                        color: "#7F92B0",
                                                                        fontWeight: 500,
                                                                    },
                                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "rgba(255,255,255,0.2)",
                                                                    },
                                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#0BD1D1",
                                                                    },
                                                                    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#0BD1D1",
                                                                        boxShadow: "0 0 6px rgba(11,209,209,0.4)",
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>

                                                        <Grid item xs={12} sm={4}>
                                                            <TextField
                                                                label="End Date"
                                                                type="date"
                                                                fullWidth
                                                                value={endDate}
                                                                onChange={(e) => setEndDate(e.target.value)}
                                                                InputLabelProps={{ shrink: true }}
                                                                sx={{
                                                                    "& .MuiInputBase-root": {
                                                                        backgroundColor: "rgba(255, 255, 255, 0.05)",
                                                                        borderRadius: "12px",
                                                                        color: "white",
                                                                        transition: "0.3s",
                                                                        "&:hover": {
                                                                            backgroundColor: "rgba(255, 255, 255, 0.08)",
                                                                        },
                                                                    },
                                                                    "& .MuiInputLabel-root": {
                                                                        color: "#7F92B0",
                                                                        fontWeight: 500,
                                                                    },
                                                                    "& .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "rgba(255,255,255,0.2)",
                                                                    },
                                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#0BD1D1",
                                                                    },
                                                                    "& .Mui-focused .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#0BD1D1",
                                                                        boxShadow: "0 0 6px rgba(11,209,209,0.4)",
                                                                    },
                                                                }}
                                                            />
                                                        </Grid>
                                                        <Grid item xs={12} sm={4}>
                                                            <Box sx={{ display: "flex", gap: 1 }}>
                                                                <Button
                                                                    variant="contained"
                                                                    onClick={handleFilter}
                                                                    fullWidth
                                                                    sx={{
                                                                        bgcolor: "#0BD1D1",
                                                                        color: "#000",
                                                                        fontWeight: 700,
                                                                        "&:hover": { bgcolor: "#0ac5c5" },
                                                                    }}
                                                                >
                                                                    Apply
                                                                </Button>
                                                                <Button
                                                                    variant="outlined"
                                                                    onClick={handleClearFilter}
                                                                    fullWidth
                                                                    sx={{
                                                                        borderColor: "#0BD1D1",
                                                                        color: "#0BD1D1",
                                                                        fontWeight: 700,
                                                                        "&:hover": { borderColor: "#0ac5c5", color: "#0ac5c5" },
                                                                    }}
                                                                >
                                                                    Clear
                                                                </Button>
                                                            </Box>
                                                        </Grid>
                                                    </Grid>
                                                </Paper>

                                                {/* Stats Cards */}
                                                <Grid container spacing={2} sx={{ mb: 3 }}>
                                                    {[
                                                        {
                                                            icon: <ShoppingBag sx={{ color: "#0BD1D1", mr: 1 }} />,
                                                            label: "Total Orders",
                                                            value: stats.totalOrders,
                                                        },
                                                        {
                                                            icon: <CheckCircle sx={{ color: "#3FBF43", mr: 1 }} />,
                                                            label: "Paid Orders",
                                                            value: stats.paidOrders,
                                                        },
                                                        {
                                                            icon: <AttachMoney sx={{ color: "#3FBF43", mr: 1 }} />,
                                                            label: "Total Earnings",
                                                            value: `$${stats.totalEarnings.toFixed(2)}`,
                                                        },
                                                        {
                                                            icon: <Pending sx={{ color: "#D4AF37", mr: 1 }} />,
                                                            label: "Unpaid Amount",
                                                            value: `$${stats.unpaidAmount.toFixed(2)}`,
                                                        },
                                                    ].map((item, i) => (
                                                        <Grid item xs={12} sm={6} md={3} key={i}>
                                                            <Card
                                                                sx={{
                                                                    borderRadius: "15px",
                                                                    bgcolor: "#1b2335",
                                                                    color: "white",
                                                                    fontSize: '12px',
                                                                    border: "1px solid rgba(255,255,255,0.1)",
                                                                    transition: "0.3s",
                                                                    "&:hover": { transform: "scale(1.02)", bgcolor: "#222b40" },
                                                                }}
                                                            >
                                                                <CardContent>
                                                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                                                        {item.icon}
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{ color: "#7F92B0", fontWeight: 600, fontSize: '12px' }}
                                                                        >
                                                                            {item.label}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Typography variant="h4" sx={{ fontWeight: 700, fontSize: '23px' }}>
                                                                        {item.value}
                                                                    </Typography>
                                                                </CardContent>
                                                            </Card>
                                                        </Grid>
                                                    ))}
                                                </Grid>

                                                {/* Orders Table */}
                                                <Paper
                                                    sx={{
                                                        borderRadius: 2,
                                                        bgcolor: "#1b2335",
                                                        border: "1px solid rgba(255,255,255,0.1)",
                                                    }}
                                                >
                                                    <Box sx={{ p: 2 }}>
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                fontWeight: 600,
                                                                color: "white",
                                                                fontFamily: "Maven Pro, sans-serif",
                                                            }}
                                                        >
                                                            Order History
                                                        </Typography>
                                                    </Box>
                                                    <TableContainer>
                                                        <Table>
                                                            <TableHead>
                                                                <TableRow sx={{ bgcolor: "transparent" }}>
                                                                    {["Order ID", "Date", "Customer", "Items", "Amount", "Status"].map(
                                                                        (header, i) => (
                                                                            <TableCell
                                                                                key={i}
                                                                                sx={{
                                                                                    fontWeight: 600,
                                                                                    color: "#0BD1D1",
                                                                                    borderBottom: "1px solid rgba(255,255,255,0.1)",
                                                                                }}
                                                                            >
                                                                                {header}
                                                                            </TableCell>
                                                                        )
                                                                    )}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {filteredOrders.length > 0 ? (
                                                                    filteredOrders.map((order) => (
                                                                        <TableRow
                                                                            key={order.id}
                                                                            hover
                                                                            sx={{
                                                                                "&:hover": { bgcolor: "#222b40" },
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            <TableCell sx={{ color: "white" }}>{order.id}</TableCell>
                                                                            <TableCell sx={{ color: "#7F92B0" }}>{order.date}</TableCell>
                                                                            <TableCell sx={{ color: "white" }}>
                                                                                {order.customer}
                                                                            </TableCell>
                                                                            <TableCell sx={{ color: "white" }}>{order.items}</TableCell>
                                                                            <TableCell sx={{ color: "#0BD1D1", fontWeight: 700 }}>
                                                                                ${order?.amount?.toFixed(2)}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Chip
                                                                                    label={order.status}
                                                                                    size="small"
                                                                                    sx={{
                                                                                        textTransform: "capitalize",
                                                                                        fontWeight: 600,
                                                                                        bgcolor:
                                                                                            order.status === "paid"
                                                                                                ? "#143D39"
                                                                                                : "#5A4A1E",
                                                                                        border:
                                                                                            order.status === "paid"
                                                                                                ? "1px solid #3FBF43"
                                                                                                : "1px solid #D4AF37",
                                                                                        color: "white",
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                ) : (
                                                                    <TableRow>
                                                                        <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                                                                            <Typography sx={{ color: "#7F92B0" }}>
                                                                                🚀 No orders found for the selected date range
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Paper>

                                            </Box>
                                        )}
                                        {activeStep === 11 && (
                                            <Box sx={{ bgcolor: "transparent", minHeight: "100vh" }}>

                                                <Typography variant="h6" sx={{ color: "white", mb: 3 }}>
                                                    My Payments
                                                </Typography>

                                                {/* Payment Method Section */}
                                                <Paper
                                                    sx={{
                                                        p: 3,
                                                        mb: 3,
                                                        borderRadius: 2,
                                                        bgcolor: "#1b2335",
                                                        border: "1px solid rgba(255,255,255,0.1)",
                                                    }}
                                                >
                                                    <Box
                                                        sx={{
                                                            display: "flex",
                                                            justifyContent: "space-between",
                                                            alignItems: "center",
                                                            mb: 2,
                                                        }}
                                                    >
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                fontWeight: 600,
                                                                color: "#0BD1D1",
                                                                fontFamily: "Maven Pro, sans-serif",
                                                            }}
                                                        >
                                                            Payment Receiving Method
                                                        </Typography>
                                                        <Button
                                                            variant="outlined"
                                                            onClick={() => setOpenMethodDialog(true)}
                                                            sx={{
                                                                borderColor: "#0BD1D1",
                                                                color: "#0BD1D1",
                                                                fontWeight: 600,
                                                                "&:hover": {
                                                                    borderColor: "#0ac5c5",
                                                                    color: "#0ac5c5",
                                                                },
                                                            }}
                                                        >
                                                            {paymentMethod ? "Update Method" : "Set Up Method"}
                                                        </Button>
                                                    </Box>

                                                    {paymentMethod ? (
                                                        <Box sx={{ color: "white" }}>
                                                            {paymentMethod.type === "bank" ? (
                                                                <Box>
                                                                    <Typography variant="body1" sx={{ mb: 1 }}>
                                                                        <strong>Type:</strong> Bank Transfer
                                                                    </Typography>
                                                                    <Typography variant="body2" sx={{ color: "#7F92B0" }}>
                                                                        Account Name: {paymentMethod.details.accountName}
                                                                    </Typography>
                                                                    <Typography variant="body2" sx={{ color: "#7F92B0" }}>
                                                                        Account Number: ••••{" "}
                                                                        {paymentMethod.details.accountNumber.slice(-4)}
                                                                    </Typography>
                                                                    <Typography variant="body2" sx={{ color: "#7F92B0" }}>
                                                                        Bank: {paymentMethod.details.bankName}
                                                                    </Typography>
                                                                </Box>
                                                            ) : (
                                                                <Box>
                                                                    <Typography variant="body1" sx={{ mb: 1 }}>
                                                                        <strong>Type:</strong> PayPal
                                                                    </Typography>
                                                                    <Typography variant="body2" sx={{ color: "#7F92B0" }}>
                                                                        Email: {paymentMethod.details.email}
                                                                    </Typography>
                                                                </Box>
                                                            )}
                                                        </Box>
                                                    ) : (
                                                        <Alert
                                                            severity="warning"
                                                            sx={{
                                                                bgcolor: "rgba(255, 193, 7, 0.1)",
                                                                color: "#D4AF37",
                                                                border: "1px solid #D4AF37",
                                                            }}
                                                        >
                                                            No payment method set up. Please add one to request payouts.
                                                        </Alert>
                                                    )}
                                                </Paper>

                                                {/* Stats Cards */}
                                                <Grid container spacing={3} sx={{ mb: 3 }}>
                                                    {[
                                                        {
                                                            icon: <AccountBalance sx={{ color: "#3FBF43", mr: 1 }} />,
                                                            label: "Total Paid",
                                                            color: "#3FBF43",
                                                            value: `$${stats2.totalPaid.toFixed(2)}`,
                                                        },
                                                        {
                                                            icon: <Payment sx={{ color: "#D4AF37", mr: 1 }} />,
                                                            label: "Pending Payouts",
                                                            color: "#D4AF37",
                                                            value: `$${stats2.totalPending.toFixed(2)}`,
                                                        },
                                                        {
                                                            icon: <TrendingUp sx={{ color: "#0BD1D1", mr: 1 }} />,
                                                            label: "Total Payouts",
                                                            color: "#0BD1D1",
                                                            value: stats2.totalPayouts,
                                                        },
                                                    ].map((item, i) => (
                                                        <Grid item xs={12} sm={4} key={i}>
                                                            <Card
                                                                sx={{
                                                                    borderRadius: "15px",
                                                                    bgcolor: "#1b2335",
                                                                    color: "white",
                                                                    border: "1px solid rgba(255,255,255,0.1)",
                                                                    transition: "0.3s",
                                                                    "&:hover": { transform: "scale(1.02)", bgcolor: "#222b40" },
                                                                }}
                                                            >
                                                                <CardContent>
                                                                    <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                                                                        {item.icon}
                                                                        <Typography
                                                                            variant="body2"
                                                                            sx={{ color: "#7F92B0", fontWeight: 600, fontSize: '12px' }}
                                                                        >
                                                                            {item.label}
                                                                        </Typography>
                                                                    </Box>
                                                                    <Typography
                                                                        variant="h4"
                                                                        sx={{ fontWeight: 700, color: item.color, fontSize: '23px' }}
                                                                    >
                                                                        {item.value}
                                                                    </Typography>
                                                                </CardContent>
                                                            </Card>
                                                        </Grid>
                                                    ))}
                                                </Grid>

                                                {/* Request Payout Button */}
                                                <Box sx={{ mb: 3 }}>
                                                    <Button
                                                        variant="contained"
                                                        size="large"
                                                        onClick={handleRequestPayout}
                                                        disabled={!paymentMethod}
                                                        sx={{
                                                            fontWeight: 700,
                                                            bgcolor: "#0BD1D1",
                                                            color: "#000",
                                                            "&:hover": { bgcolor: "#0ac5c5" },
                                                        }}
                                                    >
                                                        Request Payout
                                                    </Button>
                                                </Box>

                                                {/* Payouts Table */}
                                                <Paper
                                                    sx={{
                                                        borderRadius: 2,
                                                        bgcolor: "#1b2335",
                                                        border: "1px solid rgba(255,255,255,0.1)",
                                                    }}
                                                >
                                                    <Box sx={{ p: 2 }}>
                                                        <Typography
                                                            variant="h6"
                                                            sx={{
                                                                fontWeight: 600,
                                                                color: "white",
                                                                fontFamily: "Maven Pro, sans-serif",
                                                            }}
                                                        >
                                                            Payout History
                                                        </Typography>
                                                    </Box>
                                                    <TableContainer>
                                                        <Table>
                                                            <TableHead>
                                                                <TableRow sx={{ bgcolor: "transparent" }}>
                                                                    {[
                                                                        "Payout ID",
                                                                        "Request Date",
                                                                        "Amount",
                                                                        "Method",
                                                                        "Status",
                                                                        "Paid Date",
                                                                    ].map((header, i) => (
                                                                        <TableCell
                                                                            key={i}
                                                                            sx={{
                                                                                fontWeight: 600,
                                                                                color: "#0BD1D1",
                                                                                borderBottom: "1px solid rgba(255,255,255,0.1)",
                                                                            }}
                                                                        >
                                                                            {header}
                                                                        </TableCell>
                                                                    ))}
                                                                </TableRow>
                                                            </TableHead>
                                                            <TableBody>
                                                                {payouts.length > 0 ? (
                                                                    payouts.map((payout) => (
                                                                        <TableRow
                                                                            key={payout.id}
                                                                            hover
                                                                            sx={{
                                                                                "&:hover": { bgcolor: "#222b40" },
                                                                                cursor: "pointer",
                                                                            }}
                                                                        >
                                                                            <TableCell sx={{ color: "white" }}>{payout.id}</TableCell>
                                                                            <TableCell sx={{ color: "#7F92B0" }}>
                                                                                {payout.requestDate}
                                                                            </TableCell>
                                                                            <TableCell sx={{ color: "#0BD1D1", fontWeight: 700 }}>
                                                                                ${payout.amount.toFixed(2)}
                                                                            </TableCell>
                                                                            <TableCell sx={{ color: "white" }}>
                                                                                {payout.method}
                                                                            </TableCell>
                                                                            <TableCell>
                                                                                <Chip
                                                                                    label={payout.status}
                                                                                    size="small"
                                                                                    sx={{
                                                                                        textTransform: "capitalize",
                                                                                        fontWeight: 600,
                                                                                        bgcolor:
                                                                                            payout.status === "paid"
                                                                                                ? "#143D39"
                                                                                                : "#5A4A1E",
                                                                                        border:
                                                                                            payout.status === "paid"
                                                                                                ? "1px solid #3FBF43"
                                                                                                : "1px solid #D4AF37",
                                                                                        color: "white",
                                                                                    }}
                                                                                />
                                                                            </TableCell>
                                                                            <TableCell sx={{ color: "#7F92B0" }}>
                                                                                {payout.paidDate || "-"}
                                                                            </TableCell>
                                                                        </TableRow>
                                                                    ))
                                                                ) : (
                                                                    <TableRow>
                                                                        <TableCell colSpan={6} align="center" sx={{ py: 4 }}>
                                                                            <Typography sx={{ color: "#7F92B0" }}>
                                                                                🚀 No payout requests yet
                                                                            </Typography>
                                                                        </TableCell>
                                                                    </TableRow>
                                                                )}
                                                            </TableBody>
                                                        </Table>
                                                    </TableContainer>
                                                </Paper>

                                                {/* Request Payout Dialog */}
                                                <Dialog
                                                    open={openRequestDialog}
                                                    onClose={() => setOpenRequestDialog(false)}
                                                    maxWidth="sm"
                                                    fullWidth
                                                    PaperProps={{
                                                        sx: { bgcolor: "#1b2335", color: "white", borderRadius: 2 },
                                                    }}
                                                >
                                                    <DialogTitle sx={{ fontWeight: 600, color: "#0BD1D1" }}>
                                                        Request Payout
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <TextField
                                                            label="Amount"
                                                            type="number"
                                                            fullWidth
                                                            value={requestAmount}
                                                            onChange={(e) => setRequestAmount(e.target.value)}
                                                            sx={{
                                                                mt: 2,
                                                                input: { color: "white" },
                                                                label: { color: "#7F92B0" },
                                                                "& .MuiOutlinedInput-root": {
                                                                    "& fieldset": { borderColor: "#7F92B0" },
                                                                    "&:hover fieldset": { borderColor: "#0BD1D1" },
                                                                },
                                                            }}
                                                            InputProps={{
                                                                startAdornment: <Typography sx={{ mr: 1 }}>$</Typography>,
                                                            }}
                                                        />
                                                        <Alert
                                                            severity="info"
                                                            sx={{
                                                                mt: 2,
                                                                bgcolor: "rgba(11,209,209,0.1)",
                                                                color: "#0BD1D1",
                                                                border: "1px solid #0BD1D1",
                                                            }}
                                                        >
                                                            Payouts will be sent to your{" "}
                                                            {paymentMethod?.type === "bank"
                                                                ? "bank account"
                                                                : "PayPal account"}
                                                            .
                                                        </Alert>
                                                    </DialogContent>
                                                    <DialogActions sx={{ p: 2 }}>
                                                        <Button
                                                            onClick={() => setOpenRequestDialog(false)}
                                                            sx={{ color: "#7F92B0" }}
                                                        >
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            onClick={handleSubmitRequest}
                                                            sx={{
                                                                bgcolor: "#0BD1D1",
                                                                color: "#000",
                                                                fontWeight: 700,
                                                                "&:hover": { bgcolor: "#0ac5c5" },
                                                            }}
                                                        >
                                                            Submit Request
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>

                                                {/* Payment Method Dialog */}
                                                <Dialog
                                                    open={openMethodDialog}
                                                    onClose={() => setOpenMethodDialog(false)}
                                                    maxWidth="sm"
                                                    fullWidth
                                                    PaperProps={{
                                                        sx: { bgcolor: "#1b2335", color: "white", borderRadius: 2 },
                                                    }}
                                                >
                                                    <DialogTitle sx={{ fontWeight: 600, color: "#0BD1D1" }}>
                                                        Set Payment Method
                                                    </DialogTitle>
                                                    <DialogContent>
                                                        <FormControl fullWidth sx={{ mt: 2 }}>
                                                            <InputLabel sx={{ color: "#7F92B0" }}>Payment Type</InputLabel>
                                                            <Select
                                                                value={methodType}
                                                                onChange={(e) => setMethodType(e.target.value)}
                                                                label="Payment Type"
                                                                sx={{
                                                                    color: "white",
                                                                    ".MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#7F92B0",
                                                                    },
                                                                    "&:hover .MuiOutlinedInput-notchedOutline": {
                                                                        borderColor: "#0BD1D1",
                                                                    },
                                                                }}
                                                            >
                                                                <MenuItem value="bank">Bank Transfer</MenuItem>
                                                                <MenuItem value="paypal">PayPal</MenuItem>
                                                            </Select>
                                                        </FormControl>

                                                        {methodType === "bank" ? (
                                                            <Box sx={{ mt: 2 }}>
                                                                {[
                                                                    ["Account Name", "accountName"],
                                                                    ["Account Number", "accountNumber"],
                                                                    ["Bank Name", "bankName"],
                                                                    ["Routing Number", "routingNumber"],
                                                                ].map(([label, field], i) => (
                                                                    <TextField
                                                                        key={i}
                                                                        label={label}
                                                                        fullWidth
                                                                        value={bankDetails[field]}
                                                                        onChange={(e) =>
                                                                            setBankDetails({ ...bankDetails, [field]: e.target.value })
                                                                        }
                                                                        sx={{
                                                                            mb: 2,
                                                                            input: { color: "white" },
                                                                            label: { color: "#7F92B0" },
                                                                            "& .MuiOutlinedInput-root": {
                                                                                "& fieldset": { borderColor: "#7F92B0" },
                                                                                "&:hover fieldset": { borderColor: "#0BD1D1" },
                                                                            },
                                                                        }}
                                                                    />
                                                                ))}
                                                            </Box>
                                                        ) : (
                                                            <TextField
                                                                label="PayPal Email"
                                                                type="email"
                                                                fullWidth
                                                                value={paypalEmail}
                                                                onChange={(e) => setPaypalEmail(e.target.value)}
                                                                sx={{
                                                                    mt: 2,
                                                                    input: { color: "white" },
                                                                    label: { color: "#7F92B0" },
                                                                    "& .MuiOutlinedInput-root": {
                                                                        "& fieldset": { borderColor: "#7F92B0" },
                                                                        "&:hover fieldset": { borderColor: "#0BD1D1" },
                                                                    },
                                                                }}
                                                            />
                                                        )}
                                                    </DialogContent>
                                                    <DialogActions sx={{ p: 2 }}>
                                                        <Button onClick={() => setOpenMethodDialog(false)} sx={{ color: "#7F92B0" }}>
                                                            Cancel
                                                        </Button>
                                                        <Button
                                                            variant="contained"
                                                            onClick={handleSavePaymentMethod}
                                                            sx={{
                                                                bgcolor: "#0BD1D1",
                                                                color: "#000",
                                                                fontWeight: 700,
                                                                "&:hover": { bgcolor: "#0ac5c5" },
                                                            }}
                                                        >
                                                            Save Method
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>

                                            </Box>
                                        )}

                                        {/* Edit Button */}
                                        {/* <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 4 }}>
                    <Button
                      variant="contained"
                      startIcon={<EditIcon />}
                      sx={{
                        background: "#00BCD4",
                        color: "#101A33",
                        px: 4,
                        py: 1.5,
                        borderRadius: 4,
                        textTransform: "none",
                        fontSize: "16px",
                        fontWeight: 700,
                        "&:hover": {
                          background: "#00ACC1",
                        },
                      }}
                    >
                      Edit Details
                    </Button>
                  </Box> */}
                                    </Box>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Box>
            </Box>
        </div>
    )
}

export default VendorDetailPage
